"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Country = void 0;
var Country = /** @class */function () {
  function Country(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['id', 'code', 'alpha2Code', 'title', 'title_native', 'flag_url'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
  }
  return Country;
}();
exports.Country = Country;
